export default[
    {
        name:'计划一',
        value:{
            accMoney:100000,
            accDrug:10000,
            accHospital:100,
            name:'计划一',
            id:287
        }
    },
    {
        name:'计划二',
        value:{
            accMoney:200000,
            accDrug:20000,
            accHospital:100,
            name:'计划二',
            id:288
        }
    },
    {
        name:'计划三',
        value:{
            accMoney:300000,
            accDrug:30000,
            accHospital:100,
            name:'计划三',
            id:289
        }
    },
    {
        name:'计划四',
        value:{
            accMoney:400000,
            accDrug:40000,
            accHospital:100,
            name:'计划四',
            id:290
        }
    },
    {
        name:'计划五',
        value:{
            accMoney:500000,
            accDrug:50000,
            accHospital:100,
            name:'计划五',
            id:291
        }
    },
    {
        name:'计划六',
        value:{
            accMoney:600000,
            accDrug:60000,
            accHospital:100,
            name:'计划六',
            id:292
        }
    },
    {
        name:'计划七',
        value:{
            accMoney:700000,
            accDrug:70000,
            accHospital:100,
            name:'计划七',
            id:293
        }
    },
    {
        name:'计划八',
        value:{
            accMoney:800000,
            accDrug:80000,
            accHospital:100,
            name:'计划八',
            id:294
        }
    },
    {
        name:'计划九',
        value:{
            accMoney:900000,
            accDrug:90000,
            accHospital:100,
            name:'计划九',
            id:295
        }
    },
    {
        name:'计划十',
        value:{
            accMoney:1000000,
            accDrug:100000,
            accHospital:100,
            name:'计划十',
            id:296
        }
    },
]
